import { render, staticRenderFns } from "./beiZhiXingRen.vue?vue&type=template&id=8118a7b8&scoped=true&"
import script from "./beiZhiXingRen.vue?vue&type=script&lang=js&"
export * from "./beiZhiXingRen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8118a7b8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\myProject\\cbi-site-front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8118a7b8')) {
      api.createRecord('8118a7b8', component.options)
    } else {
      api.reload('8118a7b8', component.options)
    }
    module.hot.accept("./beiZhiXingRen.vue?vue&type=template&id=8118a7b8&scoped=true&", function () {
      api.rerender('8118a7b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/workplace/components/company/beiZhiXingRen.vue"
export default component.exports